import { render, staticRenderFns } from "./IconMenuAlt4Solid.vue?vue&type=template&id=1d4f37d5"
import script from "./IconMenuAlt4Solid.vue?vue&type=script&lang=js"
export * from "./IconMenuAlt4Solid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports